import { UserScopesT } from 'business/definitions';
import { VisionState } from 'components/App/models';
import { useSelector } from 'react-redux';
import { getUserScopesPostProcessingMiddleware } from './getScopesMiddlewares';

export const useGetUserScopes = (): UserScopesT =>
    getUserScopesPostProcessingMiddleware(
        useSelector(
            (state: { vision: VisionState }) => state.vision.user.scopes,
        ),
    );
